export const messageListAriaLabel = "EmU0Xc";
export default {messageListAriaLabel};